import React, { Suspense, lazy, useMemo } from 'react';
import { readRepoFile, writeRepoFile } from './doctorApi';
import { launchErrors } from './launchSchema';

// The FTP/SFTP file editor (Monaco, conflict check, diff), loaded on demand:
// it imports the Tauri API statically, which the project page must not.
const FileEditModal = lazy(() => import('../../../FileEditModal'));

export const LAUNCH_FILE = '.apiboo/launch.json';

/**
 * A repo file in the FTP/SFTP editor modal: `.apiboo/launch.json` (JSON
 * highlighting, schema checked before Save — Rust checks again and never
 * writes an invalid file) or an env file (`.env`, INI highlighting).
 * Reads and writes go through `run_file_read` / `run_file_write` (inside
 * the repo, no link out of it).
 */
export default function RunFileEditor({ repoPath, rel, onClose, onSaved }) {
  const backend = useMemo(
    () => ({
      read: () => readRepoFile(repoPath, rel),
      write: (content, expectedMtime) => writeRepoFile(repoPath, rel, content, expectedMtime),
    }),
    [repoPath, rel]
  );
  if (!rel) return null;
  const isLaunch = rel.replace(/\\/g, '/') === LAUNCH_FILE;
  const name = rel.split('/').pop();
  return (
    <Suspense fallback={null}>
      <FileEditModal
        isOpen
        local
        path={rel}
        name={name}
        backend={backend}
        validate={isLaunch ? launchErrors : null}
        onClose={onClose}
        onSaved={onSaved}
      />
    </Suspense>
  );
}
